'use client'

import RouteErrorFallback from '@/components/RouteErrorFallback'

type ErrorProps = {
  error: Error & { digest?: string }
  unstable_retry: () => void
}

export default function Error({ error, unstable_retry }: ErrorProps) {
  return <RouteErrorFallback error={error} retry={unstable_retry} segment="profile-detail" />
}
